import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {debounceTime, distinctUntilChanged, Observable, of, switchMap} from 'rxjs';
import {Dealer} from '../../../../domain/data/customer-client-response.data';

@Component({
  selector: 'app-registration-preferred-dealer',
  imports: [
    ReactiveFormsModule,
  ],
  templateUrl: './registration-preferred-dealer.component.html'
})
export class RegistrationPreferredDealerComponent implements OnInit, OnChanges {
  @Input() brand?: string;
  @Input() allDealerList: Dealer[] = [];
  @Input() selectedDealer?: Dealer;
  @Output() dealerSelected = new EventEmitter<Dealer | null>();

  dealerControl = new FormControl('');
  filteredDealers: Dealer[] = [];
  dropdownVisible = false;
  currentSelectedDealer?: Dealer;

  @ViewChild('inputElement') inputElement?: ElementRef<HTMLInputElement>;

  ngOnInit(): void {
    this.dealerControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(value => this.filterDealers(value))
    ).subscribe(filtered => {
      this.filteredDealers = filtered;
      const inputLength = this.dealerControl.value ? this.dealerControl.value.length : 0;
      this.dropdownVisible = filtered.length > 0 || inputLength > 2;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDealer']) {
      if (this.selectedDealer) {
        this.currentSelectedDealer = this.selectedDealer;
        this.dealerControl.setValue(this.selectedDealer.name, { emitEvent: false });
      } else {
        this.currentSelectedDealer = undefined;
        this.dealerControl.setValue('', { emitEvent: false });
      }
    }
  }

  filterDealers(query: string): Observable<Dealer[]> {
    if (!query || query.length < 3) {
      return of([]);
    }

    const filtered = this.allDealerList.filter(d =>
      d.name.toLowerCase().includes(query.toLowerCase()) ||
      d.street.toLowerCase().includes(query.toLowerCase()) ||
      d.postcode.toLowerCase().includes(query.toLowerCase()) ||
      d.city.toLowerCase().includes(query.toLowerCase())
    );
    return of(filtered);
  }

  get noResults(): boolean {
    return this.filteredDealers.length === 0 && this.dealerControl.value?.length > 2;
  }

  onFocus() {
    const inputLength = this.dealerControl.value ? this.dealerControl.value.length : 0;
    if (this.filteredDealers.length > 0 || inputLength > 2) {
      this.dropdownVisible = true;
    }
  }

  onBlur() {
    setTimeout(() => {
      this.dropdownVisible = false;

      const currentValue = this.dealerControl.value?.trim() ?? '';
      if (this.currentSelectedDealer && currentValue !== this.currentSelectedDealer.name) {
        this.dealerControl.setValue(this.currentSelectedDealer.name, { emitEvent: false });
      }

      if (!this.currentSelectedDealer && currentValue !== '') {
        this.dealerControl.setValue('', { emitEvent: false });
      }
    }, 200);
  }

  selectDealer(dealer: Dealer) {
    this.currentSelectedDealer = dealer;
    this.dealerControl.setValue(dealer.name, { emitEvent: false });
    this.dropdownVisible = false;
    this.dealerSelected.emit(dealer);
  }

  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;

    if (!value) {
      this.currentSelectedDealer = undefined;
      this.dealerSelected.emit(null);
    }
  }
}
